export default function ConfirmModal({
  title = null,
  message = null,
  confirmText = null,
  cancelText = null,
  onClose,
}) {
  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <h2>{title}</h2>

        <p>{message}</p>

        <div className="modal-actions">
          <button
            className="delete_approve_btn"
            onClick={() => onClose("yes")}
          >
            {confirmText}
          </button>
          <button
            className="delete_reject_btn"
            onClick={() => onClose("no")}
          >
            {cancelText}
          </button>

        </div>
      </div>
    </div>
  );
}